import React from "react";

import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const RecipeSkeleton: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid
        size={12}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Skeleton variant="rounded" width={240} height={32} />
        <Skeleton variant="rounded" width={100} height={32} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="rounded" height={40} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="rounded" height={300} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="rounded" height={300} />
      </Grid>
    </Grid>
  );
};
